<script setup lang="ts">
import { onMounted } from 'vue';
import { useNotification } from 'naive-ui';
import { usePlanRunPolling } from '@/composables/use-plan-run';
import { usePlanRunStore } from '@/stores/trajectory/plan-run-store';
import { useOrganizationStore } from '@/stores/organization/organization-store';
import { useAuthStore } from '@/stores/authentication-store';
import { useMessageHandler } from '@/helpers/error/useMessageHandler';
import PlanRunProgressPanel from '@/components/transport/plan-run/PlanRunProgressPanel.vue';
import PlanRunSummaryModal from '@/components/transport/plan-run/PlanRunSummaryModal.vue';

const authStore = useAuthStore();
const planRunStore = usePlanRunStore();

/*
  De meldingen-API wordt normaal door DefaultLayout geregistreerd, maar die laadt lazy terwijl de poller zijn
  eerste ronde meteen na het mounten draait. Landt de afloop van een run in dat gat, dan viel showNotification
  over een lege API en zag de planner niets. Deze provider hangt binnen n-notification-provider en kan hem dus
  zelf borgen; ?? = laat de registratie van de layout ongemoeid zodra die er is.
*/
useMessageHandler().notification ??= useNotification();

/*
  De voortgangsweergave hangt app-breed en niet aan de dagplanner: een run duurt al gauw enkele minuten, en
  de planner werkt in die tijd verder op de trajecten- of transportlijst. Prijs daarvan is één extra
  statusopvraging per twintig seconden op elke pagina — één rij, geen joins. De poller slaat zelf over
  wanneer er niemand is ingelogd of het tabblad op de achtergrond staat.
*/
usePlanRunPolling();

onMounted(async () => {
  await authStore.ensureHydrated();

  if (authStore.isAuthenticated()) {
    // Voor het zoekbudget waarop de balk tijdens het oplossen meeloopt. Deze opvraging gaat maximaal één
    // keer per organisatie over de lijn.
    await useOrganizationStore().ensureOrganizationSettings(authStore.organizationId);
  }
});
</script>

<template>
<!-- Ook in samengevouwen vorm: het paneel beslist zelf welke van de twee het toont. -->
<plan-run-progress-panel v-if="planRunStore.showProgressPanel || planRunStore.showMinimizedProgress" />
<!--
  De samenvatting hangt hier en niet aan de dagplanner: de planner werkt tijdens een run gewoon verder op de
  trajecten- of transportlijst, en de afloop van zíjn run hoort hij te zien waar hij op dat moment ook is.
-->
<plan-run-summary-modal />
</template>

<style scoped lang="scss">
</style>
